<template>
    <div class="c-selected__item">
        <div class="c-selected__item-title">{{ title }}</div>
        <div class="c-selected__item-value">{{ selectedName }}</div>
    </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
    name: "ConfiguratorSelectedItem",
    props: ['stepProp', 'indexProp'],
    data() {
        return {
            index: 0,
        }
    },
    computed: {
        ...mapState(['moduleConfigurator']),
        selectedName() {
            return this.moduleConfigurator.steps[this.indexProp - 1].SELECTED.name ? this.moduleConfigurator.steps[this.indexProp - 1].SELECTED.name : '-';
        },
        title() {
            return this.index + '. ' + this.moduleConfigurator.steps[this.indexProp - 1]['SELECT_TITLE'];
        }
    },
    created() {
        this.index = this.indexProp;
    }
}
</script>

<style scoped>

</style>